import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CircularProgress, Tooltip } from "@mui/material"
import { Box } from "@mui/system"
import React, { MouseEventHandler } from "react"

interface ListActionButtonProps {
  tooltip: string
  icon: IconDefinition
  className?: string
  id?: string
  disabled?: boolean
  isLoading?: boolean
  bigSize?: boolean
  onClick: (event: MouseEventHandler) => any
  onDisabledClick?: (event: MouseEventHandler) => any
}

export const ListActionButton = React.memo(
  ({
    tooltip,
    icon,
    id,
    className,
    isLoading,
    disabled,
    bigSize,
    onClick,
    onDisabledClick
  }: ListActionButtonProps): JSX.Element => (
    <>
      {isLoading ? (
        <CircularProgress id={id ? `${id}-circular` : undefined} size="small" sx={{ width: "1rem", height: "1rem" }} />
      ) : (
        <Tooltip title={tooltip}>
          <Box
            id={id}
            onClick={(event: any) => {
              event.stopPropagation()
              event.preventDefault()
              if (disabled) {
                if (onDisabledClick) {
                  onDisabledClick(event)
                }
                return
              }
              onClick(event)
            }}
            className={className}
            sx={{
              ".icon-button": {
                cursor: "pointer",
                color: theme => theme.palette.text.primary2,
                transition: "color 400ms ease"
              },
              "& .icon-button:hover": {
                color: theme => theme.palette.special
              },
              "& .icon-button.disabled": {
                color: theme => theme.palette.text.disabled,
                cursor: "default"
              }
            }}>
            <FontAwesomeIcon
              icon={icon}
              className={`icon-button ${disabled ? "disabled" : ""}`}
              fontSize={bigSize ? "1.2rem" : undefined}
            />
          </Box>
        </Tooltip>
      )}
    </>
  )
)
